define('directives/checkBrower/check-brower.directive',['app'],function (app) {
    app.directive('checkBrower',function () {
        return {
            restrict: 'EA',
            templateUrl: 'directives/checkBrower/check-brower.template.html',
            replace: true,
            scope: false,
            link:function ($scope) {
                $scope.showBrower = false;
                //读取浏览器信息，展示浏览器提醒
                var browser = AUI.BaseJSUtil.getBrower();
                if (browser.ie && browser.ie.split('.')[0] < 10) {
                    $scope.showBrower = true;
                } else if (browser.firefox && browser.firefox.split('.')[0] < 50 && browser.firefox.split('.')[0] != 39) {
                    $scope.showBrower = true;
                } else if (browser.chrome && browser.chrome.split('.')[0] < 56) {
                    $scope.showBrower = true;
                }
                $scope.closeBrower = function() {
                    $scope.showBrower = false;
                };
            }
        }
    })
});
